import { API_ENDPOINTS } from '../constants'
import ApiService from './apiService'
import http from './http'

export default {
  async all({ page, filters }) {
    const params = {
      page,
      filters
    }

    const url = ApiService.buildUrl(API_ENDPOINTS.xards)
    let { data } = await http.get(url, { params })

    return data
  },

  async last({ page, query }) {
    const params = {
      page,
      query
    }

    const url = ApiService.buildUrl(API_ENDPOINTS.lasts)
    let { data } = await http.get(url, { params })

    return data
  },

  async find(id) {
    const url = ApiService.buildUrl(API_ENDPOINTS.xard, { id })
    let { data } = await http.get(url)

    return data
  },

  async linkXard(xard, toXard) {
    const url = ApiService.buildUrl(API_ENDPOINTS.xardLinks, { id: xard.id })
    let { data } = await http.post(url, { link_id: toXard.id })

    return data
  }
}
